var Backbone = require('backbone');
var _ = require('underscore');

var SubSection = require('front/pages/Section/SubSection');

require('./Service.less');

module.exports = SubSection.extend({
    initialize: function (options) {
        SubSection.prototype.initialize.call(this, options);
        _.bindAll(this, 'activateLogic');

        if (options.server) {
            this.activateLogic();
        }
    },

    render: function () {
        SubSection.prototype.render.call(this);

        this.activateLogic();
    },

    activateLogic: function () {
        var $headerWrapper = this.$('.Service-headerWrapper');

        this.$header = this.$('.Service-header');

        $headerWrapper.css('height', $headerWrapper.height());

        this.onScroll.__throttled = _.throttle(this.onScroll.bind(this), 20);
        $(window).on('scroll', this.onScroll.__throttled);

        this.onResize.__throttled = _.throttle(this.onResize.bind(this), 20);
        $(window).on('resize', this.onResize.__throttled);

        this.onScroll.__throttled();
    },

    onScroll: function () {
        var navHeight = app.views.nav.$el.outerHeight();
        var headerWrapperTop = this.$('.Service-headerWrapper').offset().top;

        if ($(window).scrollTop() >= headerWrapperTop - navHeight) {
            this.$header.addClass('Service-header--isFixed');
        } else {
            this.$header.removeClass('Service-header--isFixed');
        }
    },

    onResize: function () {
        this.onScroll.__throttled();
    },

    destroy: function () {
        $(window).unbind('scroll', this.onScroll.__throttled);
        $(window).unbind('resize', this.onResize.__throttled);

        SubSection.prototype.destroy.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Service/Service.js
// module id = 10
// module chunks = 0